import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { Link } from 'office-ui-fabric-react'
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
import { IHealingCompleteParams } from "../Interface/Params/IAutoHealingPayload"
import { Checkbox, PrimaryButton } from '@fluentui/react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import CustomMessageAlert from "../CustomMessageAlert/CustomMessageAlert";
import { getMakeasReviewed } from "../../redux/Actions/PowerDataQuery";
import { useNavigate } from "react-router-dom";

// import healing HealingComplete.css
import './HealingComplete.css'

const actionCreators = {};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
  reviewContent: state.reviewContent
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

interface IMessageState {
  showMessage: boolean,
  messageType: string,
  message: string,
  onDismiss?: () => void
}

function HealingComplete(props: StoreProps & DispatchProps) {
  const history = useNavigate();

  const [checkbox, setCheckbox] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [messageState, setMessageState] = useState<IMessageState>(() => {
    return {
      showMessage: false,
      messageType: '',
      message: '',
      onDismiss: null
    }
  })

  const completeParams = (useLocation().state || {}) as IHealingCompleteParams;
  const autohealingBaseUrl = process.env.REACT_APP_WEBAPP_REDIRECTURL;


  function renderContent() {
    let autohealingUrl = `${autohealingBaseUrl}/apps/${completeParams?.fixerPath}?url=${completeParams?.requesturl}&traceID=${completeParams?.traceID}&CurationID=${completeParams?.curationID}`

    let c3Link = `https://authoring.support.microsoft.com/repo/${props.reviewContent?.RepoName}/content/preview/.c/${props.reviewContent?.C3FilePath}`
    let contentideaLink = ''
    if (props.reviewContent?.CIID) {
      contentideaLink = `https://aka.ms/CIEdit?id=${props.reviewContent?.CIID}`
    }

    switch (completeParams?.reviewType) {
      case "Close":
        return (
          <div className='autohealing-complete-content'>
            <span>Thank you for reviewing the change. You can now close this page.</span>
          </div>
            )
      case "Replace":
      case "Approve":
        return (
          <div className='autohealing-complete-content'>
            <span>Perfect! Thank you for reviewing and approving the change. This change will take up to 30 minutes to take effect. You can now close this page.</span>
          </div>
        )
      case "Exception":
        return (
          <div className='autohealing-complete-content'>
            <span>All changes have been reversed and the page can be closed now. You can click the <a href={autohealingUrl}>link</a> to reopen the page if any change is needed.</span>
          </div>
        )
      case "ManuallyFix":
        return (
          <div className='autohealing-complete-content'>
            {
              contentideaLink ?
                <span>You can select one of the following authoring tools to resolve the issue. You can reopen this <a href={autohealingUrl}>link</a> to modify your selection if you change your mind.</span>
                :
                <span>You can select the following authoring tool to resolve the issue. You can reopen this <a href={autohealingUrl}>link</a> to modify your selection if you change your mind.</span>
            }
            <ul>
              {
                completeParams.actionLink.length > 0 ? (
                  completeParams.actionLink.map((item: any, index) => (
                    <li key={index}>
                      <Link href={item.Url}>{item.Name}</Link>
                    </li>
                  ))
                ) : (
                  <>
                    {contentideaLink && (
                      <li>
                        <Link href={contentideaLink}>Content Idea</Link> (For internal technical content)
                      </li>
                    )}
                    <li>
                      <Link href={c3Link}>C3</Link>
                    </li>
                  </>
                )
              }
            </ul>
          </div>
        )
      case "NoBrokenLink":
      case "TextCrawler":
        return (
          <div className='autohealing-complete-content'>
            <span>There does not appear to be any issues with this article, as it may have already been fixed. Note that this fix of the issue may take up to 24 hours to synchronize and reflect in the Sonic system. To ensure that you are viewing the latest version of the article, you can choose from one of the authoring tools provided.</span>
            <ul>
              {contentideaLink && (
                <li>
                  <Link href={contentideaLink}>Content Idea</Link> (For internal technical content)
                </li>
              )}
              <li>
                <Link href={c3Link}>C3</Link>
              </li>
            </ul>
          </div>
        )
      case "NoPermission":
        return (
          <div className='autohealing-complete-content'>
            <span>Unfortunately, the requested page could not be found. Please check if the page link is correct or confirm if you are a contributor to the article you are requesting.</span>
          </div>
        )
      case "MarkeAsReview":
        return (
          <div className='autohealing-complete-content'>
            <div>
              <h2 style={{ fontSize: "25px", fontWeight: "600" }}>
                You successfully submitted the choice.
              </h2>
            </div>
            <ul>
              <li>If you selected "Mark as reviewed," this article has been renewed for the next {completeParams?.renewDays} days.</li>
              <li>If you selected "Improve this article," you need to modify this article within the next {completeParams?.archiveDays} days and republish it.</li>
              <li>If you selected "Archive this article," you need to archive this article within the next {completeParams?.archiveDays} days. </li>
            </ul>
          </div>
        )
      default:
        return (
          <div className='autohealing-complete-content'>
            <span>Thank you for reviewing the change. You can now close this page.</span>
          </div>
        )
    }
  }

  function clickMakeasReviewed(rollback) {
    var data = {
      ticketGuid: completeParams?.ticketID,
      curationId: completeParams?.curationID,
      dataMart: completeParams?.datamart,
      rollback: rollback,
    }

    setIsSubmitting(true)
    getMakeasReviewed(data).then(res => {
      setIsSubmitting(false)

      if (res.Success) {
        setMessageState({
          messageType: 'success',
          showMessage: true,
          message: 'Congratulations, you have successfully reversed the review action. Please re-attest your article.'
        })

        setTimeout(() => {
          var url = `/apps/stale?url=${completeParams.articleUrl}&curationID=${completeParams.curationID}&jobID=
            ${completeParams.jobID}&ticketID=${completeParams.ticketID}`;
          if (completeParams.datamart != null && completeParams.datamart != "") {
            url += `&datamart=${completeParams.datamart}`;
          }
          history(url);
        }, 1500);
      } else {
        setMessageState({
          messageType: 'error',
          showMessage: true,
          message: `${res.ErrorMessage}`,
          onDismiss: dismissAlert
        })
      }

      setTimeout(() => {
        dismissAlert();
      }, 3500);

    });
  }

  const dismissAlert = () => {
      setMessageState({
          messageType: '',
          showMessage: false,
          message: ''
      })
  }


  return (
    <div style={{ margin: "30px 80px 0 80px" }}>
      <div style={{ width: '50%', position: 'relative', marginLeft: "5%" }}>
        <CustomMessageAlert
          type={messageState.messageType}
          message={messageState.message}
          showAlert={messageState.showMessage}
          onDismiss={messageState.onDismiss}
        />
      </div>

      <div className='autohealing-complete-title'>
        <span>{completeParams ? completeParams.completeTitle : "Thank you!"}</span>
      </div>
      {renderContent()}
      <div className="autohealing-complete-footer">For information on how to update internal content, please refer to this article: <a href='https://internal.evergreen.microsoft.com/en-us/topic/0bfe63e9-47b4-40f0-a35d-9f9aa0e58b21'>Internal Support Content request landing page</a>.</div>

      {
        completeParams?.reviewType == "MarkeAsReview" ?
          <div style={{ width: "50%" }}>
            <div>
              <h3 style={{ fontSize: "20px", fontWeight: "500", marginLeft: "5px" }}>
                Note that You still can revert the review action:
              </h3>
            </div>
            <div style={{ paddingLeft: "10px" }}>
              {/* <Checkbox
                onChange={(event, checked) => (setCheckbox(checked))}
                checked={checkbox}
                className='customCheckbox'
                label={<>
                  As an accountable owner of this article, by clicking on <span className='fontWeight'>Mark as not reviewed</span>.
                  I am aware that any review action I submitted for this article will be reverted.
                </>}
              /> */}
              
              <Checkbox
                onChange={(event, checked) => (setCheckbox(checked))}
                checked={checkbox}
                className='customCheckbox'
                onRenderLabel={() => (
                  <span>
                    As an accountable owner of this article, by clicking on <span className='fontWeight'>Mark as not reviewed</span>.
                    I am aware that any review action I submitted for this article will be reverted.
                  </span>
                )}
              />

            </div>
            <div className='button-top'>
              {/* <Button text="Mark as not reviewed" disabled={!checkbox} iconProps={{ iconName: "CheckMark" }} primary={true} style={{ width: "240px" }} onClick={() => {
                clickMakeasReviewed(true);
              }} /> */}

              <PrimaryButton
                text="Mark as not reviewed"
                iconProps={{ iconName: 'CheckMark' }}
                disabled={!checkbox}
                style={{ width: '240px' }}
                onClick={() => clickMakeasReviewed(true)}
              />
              
            </div>
          </div> : null
      }

      {
        isSubmitting && <Spinner className='autohealing-loading' label='Submitting...' size={SpinnerSize.large} />
      }

    </div>
  )
}

export default connect<StoreProps, DispatchProps>(
  mapStateToProps,
  bindActionCreators.bind({}, actionCreators)
)(HealingComplete);
